import { render, staticRenderFns } from "./CrowdxScreen.vue?vue&type=template&id=290f848c&scoped=true"
import script from "./CrowdxScreen.vue?vue&type=script&lang=js"
export * from "./CrowdxScreen.vue?vue&type=script&lang=js"
import style0 from "./CrowdxScreen.vue?vue&type=style&index=0&id=290f848c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290f848c",
  null
  
)

export default component.exports